// extracted by mini-css-extract-plugin
export default {"component-id-tag":"InputMaterialCard_component-id-tag__8BnCS","manual-entry-tag":"InputMaterialCard_manual-entry-tag__e5g5K"};